<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents"><span>Contents</span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0001#auto_bookmark_table_of_contents_1">Book Description</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0002#auto_bookmark_table_of_contents_1">Other Allen Drury Titles from WordFire</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0003#auto_bookmark_table_of_contents_1">Title Page</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0005#auto_bookmark_table_of_contents_1">Dedication</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0006#auto_bookmark_table_of_contents_1">Major Characters in the Novel</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0007#auto_bookmark_table_of_contents_1">Publisher’s Foreword</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0008#auto_bookmark_table_of_contents_1">Note to the Reader</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0009#auto_bookmark_table_of_contents_1">BOOK ONE</a></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0010#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">BOOK TWO</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0011#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">BOOK THREE</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0012#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">BOOK FOUR</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0013#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">BOOK FIVE</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0014#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Appendix</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0015#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">About the Author</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0016#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Other WordFire Titles</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?552c90e8